export const googleReviews = [
  {
    id: 1,
    author: "Haresh Jambhale",
    role: "Fish Curry Rice Restaurant",
    rating: 5,
    text: "It was great working with Ascent Inspecta. Thank you for sharing your knowledge & ideas relating to our projects. I always enjoy working with vendot like you"
  },
  {
    id: 2,
    author: "Pardeep Sharma",
    role: ".",
    rating: 5,
    text: "The best thing about Ascent Inspecta is their commitment and delivery package. Whatever they have committed they were able to help us to deliver on time. Their staff and company partners are very helpful and we're available as per request. Good luck for your new opportunities"
  },
  {
    id: 3,
    author: "Ashish Chaturvedi",
    role: ".",
    rating: 5,
    text: "It has been a great experience in working with Ascent Insecta and thorough Professional Satyjeet Sharma for their command on the subject and understanding of customer expectations.."
  },
  {
    id: 4,
    author: "Praveen Luthra",
    role: ".",
    rating: 5,
    text: "I used their services and found it very satisfactory and up to the mark... Staff is very co operative... I wish they continue their services with the same enthusiasm.."
  },
  {
    id: 5,
    author: "sumit ale",
    role: ".",
    rating: 5,
    text: "good service rendered by Ascent inspecta.Highly recommended.."
  },
  {
    id: 6,
    author: "GHANANAND RIKHARI",
    role: ".",
    rating: 5,
    text: "Very good service, had an amazing experience with Ascent Inspects.  I suggest  everyone  to try it.."
  }
];